import { ChangeDetectionStrategy, Component } from '@angular/core';

/** A first-load placeholder row: the data row's frame, pulsing as one solid block. */
@Component({
  selector: 'fr8bot-ui-table-skeleton-row',
  host: {
    class: 'tw:animate-pulse',
    'aria-hidden': 'true',
  },
  templateUrl: './table-skeleton-row.component.html',
  styleUrl: './table-skeleton-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSkeletonRowUIComponent {}
